import React from "react";
import { Select } from "antd";

const CustomSelect = ({
    defaultValue,
    style,
    options = [],
    onChange,
    value,
    ...rest
}) => {
    return (
        <Select
            defaultValue={defaultValue}
            style={style}
            onChange={onChange}
            options={options}
            value={value}
            {...rest}
        />
    );
};

export default CustomSelect;
